export default __webpack_public_path__ + "static/media/ga.337f88ad.svg";